<!-- <div class="flex flex-col gap-5">
  <patient-dashboard-stats
    [cards]="[
      {
        title: 'Upcoming Appointments',
        subtitle: 'appointments',
        value: '2',
        icon: 'pi-calendar',
        accent: 'primary',
      },
      {
        title: 'Completed Visits',
        subtitle: 'visits',
        value: '1',
        icon: 'pi-check-circle',
        accent: 'success',
      },
      {
        title: 'Pending Payments',
        subtitle: 'payment due',
        value: '₹1500',
        icon: 'pi-minus-circle',
        accent: 'warn',
      },

    ]"
  />

  <div class="grid grid-cols-1 xl:grid-cols-2 gap-5">
    <patient-upcoming-appointments
      [items]="[
        {
          doctorName: 'Dr. Sarah Johnson',
          title: 'First Consultation',
          date: 'Oct 10, 2025',
          time: '10:00 AM',
          status: 'Upcoming',
        },
        {
          doctorName: 'Dr. Michael Chen',
          title: 'Follow-up',
          date: 'Oct 15, 2025',
          time: '02:30 PM',
          status: 'Upcoming',
        },
      ]"
      (appointmentClick)="onUpcomingAppointmentClick($event)"
    />

    <patient-recent-appointments
      [item]="{
        doctorName: 'Dr. Sarah Johnson',
        title: 'First Consultation',
        date: 'Sep 20, 2025',
        status: 'Completed',
      }"
      (appointmentClick)="onRecentAppointmentClick($event)"
    />
  </div>

  <patient-payment-history
    [rows]="[
      {
        date: 'Sep 20, 2025',
        description: 'First Consultation - Dr. Sarah Johnson',
        amount: 1500,
        status: 'Paid',
      },
      {
        date: 'Oct 10, 2025',
        description: 'First Consultation - Dr. Sarah Johnson',
        amount: 1500,
        status: 'Pending',
      },
    ]"
  />
</div>
 -->

<!-- this is new  -->

<div class="-wrapper">
  <div class="p-container p-3">
    <h2 class="font-semibold text-xl">Overall Progress</h2>
    <p class="text-sm text-gray-500">
      Last Assessment Date: {{ eligibilityData?.last_assessment_date | date }}
    </p>

    <!-- <div>
      <p
        class="text-sm font-medium"
        [ngClass]="{
          'text-green-600': eligibilityData?.canTakeAssessment,
          'text-red-600': !eligibilityData?.canTakeAssessment
        }"
      >
        {{ eligibilityData?.canTakeAssessment ? 'You are eligible for a new assessment.' : 'You are not eligible for a new assessment yet.' }}
      </p>
      <p *ngIf="!eligibilityData?.canTakeAssessment" class="text-sm text-gray-500">
        Next Eligible Date: {{ eligibilityData?.next_eligible_date | date }}
      </p>
    </div> -->

    <div>
      <patient-assessment-guid *ngIf="eligibilityData?.can_take_assessment"></patient-assessment-guid>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-12 gap-1 md:gap-6">
      <!-- Left section (2 small cards) -->
      <div class="col-span-12 md:col-span-6 mt-6 mb-5">
        <div class="grid grid-cols-a1 md:grid-cols-2 gap-4">
          <patient-score-card-small [score]="dashboardStats?.assessment_data?.total_score">
          </patient-score-card-small>

          <patient-bmi-card-small [bmiValue]="dashboardStats?.bmi_data?.bmi_value">
          </patient-bmi-card-small>
        </div>
      </div>

      <!-- Right section (hydration card) -->
      <div class="col-span-12 md:col-span-6 mt-3 md:mt-6 mb-5">
        <patient-hydration-card
          [hydrationData]="dashboardStats?.hydration_data"
          (hydrationUpdated)="loadDashboardStats(patientId)"
        ></patient-hydration-card>
      </div>
    </div>
    <div>
      <patient-activity-tracking></patient-activity-tracking>
    </div>

    <!-- <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <main-bmi-card></main-bmi-card>
      <main-assessment-score-card></main-assessment-score-card>
    </div> -->

    <div class="mt-5" >
        <patient-dashboard-stats
      [cards]="[
        {
          title: 'Upcoming Appointments',
          subtitle: 'appointments',
          value: '2',
          icon: 'pi-calendar',
          accent: 'primary',
        },
        {
          title: 'Completed Visits',
          subtitle: 'visits',
          value: '1',
          icon: 'pi-check-circle',
          accent: 'success',
        },
        {
          title: 'Pending Payments',
          subtitle: 'payment due',
          value: '₹1500',
          icon: 'pi-minus-circle',
          accent: 'warn',
        },
      ]"
    />

    </div>



    <patient-upcoming-appointments />

    <patient-payment-history
      [payments]="[
        {
          date: 'Sep 20, 2025',
          description: 'First Consultation - Dr. Sarah Johnson',
          amount: 1500,
          status: 'Paid',
        },
        {
          date: 'Oct 10, 2025',
          description: 'First Consultation - Dr. Sarah Johnson',
          amount: 1500,
          status: 'Pending',
        },
        {
          date: 'Oct 10, 2025',
          description: 'First Consultation - Dr. Sarah Johnson',
          amount: 1500,
          status: 'Pending',
        },
        {
          date: 'Oct 10, 2025',
          description: 'First Consultation - Dr. Sarah Johnson',
          amount: 1500,
          status: 'Paid',
        },
      ]"
    />

    <patient-reports-uploaded [reports]="reports" />
  </div>

  <!-- <div class="dashboard-right bg-[#f2f2f2] dark:bg-[#1B3C53]">
    <div class="calender">
      <p-calendar [(ngModel)]="date" />
    </div>

    <patient-recent-appointments
      [items]="[
        {
          doctorName: 'Dr. Sarah Johnson',
          title: 'First Consultation',
          date: 'Sep 20, 2025',
          status: 'Completed',
          time: '21:00:220',
        },
      ]"
      (appointmentClick)="onRecentAppointmentClick($event)"
    />
  </div> -->

  <p-drawer
    [(visible)]="visible"
    position="right"
    [modal]="true"
    [dismissible]="false"
    appendTo="body"
    (onHide)="onHide()"
    styleClass="w-full sm:w-[500px]"
  >
    <ng-container *ngIf="sidebarData">
      <h3 class="mb-5 text-lg font-semibold tracking-tight">Appointment Details</h3>

      <!-- Details Cards -->
      <div class="space-y-2">
        <div
          *ngFor="let item of sidebarData | keyvalue"
          class="w-full rounded-xl border border-gray-100 px-5 py-3 shadow-[0_1px_3px_rgba(0,0,0,0.06)] hover:bg-gray-50 transition"
        >
          <p class="text-xs font-medium uppercase tracking-wide text-gray-400">
            {{ formatKey(item.key) }}
          </p>

          <p class="mt-0.5 text-sm font-medium truncate">
            {{ formatValue(item.value) }}
          </p>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="mt-6 space-y-2">
        <!-- Reschedule -->
        <button
          class="w-full rounded-xl border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-900 hover:bg-gray-100 transition"
          (click)="onReschedule()"
        >
          Reschedule Appointment
        </button>

        <!-- Cancel -->
        <button
          class="w-full rounded-xl bg-red-500 px-4 py-2.5 text-sm font-medium text-white hover:bg-red-600 transition"
          (click)="onCancel()"
        >
          Cancel Appointment
        </button>
      </div>
    </ng-container>
  </p-drawer>
</div>
